// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUi from "element-ui";
import echarts from "echarts";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN";
import common from "../common_function/common";
import $ from "jquery";
import "./assets/icon/iconfont.css";
import Http from "../common_function/http";
import store from "./store/index";
import "amfe-flexible/index.js";

// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import Avue from "@smallwei/avue";
// import "@smallwei/avue/lib/index.css";
import touch from "vue-directive-touch";
Vue.use(touch);

// import VueAMap from "vue-amap";

// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: "783405b7beb8be1cc7f72dc79cf4e178",
//   plugin: ["AMap.Geolocation"]
// });
import vRggion from "v-region";
import VueResource from "vue-resource";
import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
import "../common_function/filter";
import VueCropper from "vue-cropper";
// Vue.use(Avue);
Vue.use(VueCropper);
Vue.use(VueDirectiveImagePreviewer);
// import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import "amfe-flexible";
// import "./iconfont/iconfont";
Vue.use(Vant);
Vue.use(VueResource);
// import './utils/rem'
//  import "./styles/common.css";
import XLSX from "xlsx";
// /common_function/commonData.js
import commonData from "../common_function/commonData";
import scroll from "vue-seamless-scroll";
import Video from "video.js";
import "video.js/dist/video-js.css";

Vue.prototype.$video = Video;
Vue.use(scroll);
Vue.use(vRggion);
Vue.prototype.commonData = commonData;

Vue.prototype.XLSX = XLSX;
// import 'echarts-gl'
Vue.config.productionTip = false;

Vue.use(ElementUi, { locale });
Vue.prototype.common = common;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Http = Http;
window.$ = window.jQuery = $;
import dataV from "@jiaminghi/data-view";
import global from "../src/components/Global"; //引用文件
Vue.prototype.GLOBAL = global; //挂载到Vue实例上面复制代码
Vue.use(dataV);
function setRem() {
  var whdef = 100 / 750; // 表示750的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName("html")[0].style.fontSize = 37.5 + "px";
}
//pc端
function setRemPC() {
  var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName("html")[0].style.fontSize = 30 + "px";
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  created() {
    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题

    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      setRem();
      window.addEventListener("resize", setRem); //浏览器窗口大小改变时调用rem换算方法
    } else {
      setRemPC();
      window.addEventListener("resize", setRemPC); //浏览器窗口大小改变时调用rem换算方法
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js